
import GwContentTemplate from '~/patterns/templates/content.vue';
import seo from '~/mixins/seo';
import getEventsPage from '~/graphql/queries/getEventsPage.graphql';
import GwPageTitle from '~/patterns/molecules/page-title/page-title';
import GwPageContainer from '~/patterns/molecules/page-container/page-container';
import FlexibleSection from '~/patterns/organisms/_flexible-section/flexible-section';
import GwPageIntro from '~/patterns/molecules/page-intro/page-intro';

export default {
    components: {
        GwContentTemplate,
        GwPageContainer,
        GwPageTitle,
        GwPageIntro,
        FlexibleSection,
    },
    mixins: [seo],
    layout: 'overview',
    data() {
        return {
            entry: null,
            notFound: null
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getEventsPage,
                { site, uri }
            );

        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }
    },
    nuxtI18n: {
        paths: {
            en: '/events-and-webinars',
            in: '/events-and-webinars',
            nl: '/events-and-webinars',
            fr: '/evenements-et-webinars',
            de: '/events-und-webinars',
            'en-Highberg': '/events-and-webinars',
            'nl-Highberg': '/events-and-webinars',
            'de-Highberg': '/events-und-webinars',
        }
    }
};
